import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/admin/login?error=google", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: data }, replace: true });
      } catch {
        navigate("/admin/login?error=google", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-charcoal" data-testid="auth-callback-loading">
      <p className="text-sm font-semibold text-white/60">Signing you in…</p>
    </div>
  );
}
